var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-footer"},[_c('div',{staticStyle:{"margin":"0 auto","width":"80px","height":"80px"},attrs:{"id":"my-qrcode"}}),_c('img',{staticStyle:{"display":"block","margin":"15px auto 20px","width":"130px"},attrs:{"src":require("@/assets/rqCode.png")}})])
}]

export { render, staticRenderFns }